module.exports = __webpack_public_path__ + "img/icon-3.00009dae.svg";